import { render, staticRenderFns } from "./RetailerTagsWidget.vue?vue&type=template&id=a1f25b58&"
import script from "./RetailerTagsWidget.vue?vue&type=script&lang=js&"
export * from "./RetailerTagsWidget.vue?vue&type=script&lang=js&"
import style0 from "./RetailerTagsWidget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports